module.exports = __webpack_public_path__ + "img/map-pattern-footer.2fc11129.png";